<Banner
    closable={true}
    close={close}
    {type}
    {text}
    {visible}
    successText={successText}
    warningText={warningText}
    on:hidden={handleBannerHidden}
/>

<script>
    import Banner from '@itslearning/prometheus/assets/feedback/Banner/v1/Banner.svelte';

    export let close;
    export let successText;
    export let warningText;
    export let type = 'success';
    export let visible = false;

    $: text = type == 'success' ? successText : warningText;

    const handleBannerHidden = () => visible = false;
</script>
